var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.372C0.004 3.752 3.752 0.004 8.372 0C12.992 0.004 16.74 3.752 16.744 8.372C16.744 12.796 9.712 18.864 8.912 19.544L8.372 20L7.832 19.544C7.032 18.864 0 12.796 0 8.372ZM4.184 8.372C4.184 10.684 6.06 12.56 8.372 12.56C10.684 12.556 12.56 10.684 12.56 8.372C12.56 6.06 10.684 4.184 8.372 4.184C6.06 4.184 4.184 6.06 4.184 8.372ZM10.884 8.372C10.884 9.75934 9.75934 10.884 8.372 10.884C6.98466 10.884 5.86 9.75934 5.86 8.372C5.86 6.98466 6.98466 5.86 8.372 5.86C9.75934 5.86 10.884 6.98466 10.884 8.372Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressIcons);
export default __webpack_public_path__ + "static/media/address_icons.00beeb03e1e1471777566089f4b90a94.svg";
export { ForwardRef as ReactComponent };